import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-faba533e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "general"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Reporte de Facturación Año 2022")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "gridlistamedicos"
}
const _hoisted_7 = { class: "card-header ta-c" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Documentos: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total Prefacturado: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Prefacturas: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total Facturado: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Facturas: ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total Refacturado: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Refacturas: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Notas de Débito: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Notas de Débito: ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Notas de Crédito por Ajuste: ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Notas de Crédito por Ajuste: ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Notas de Crédito por Reenvío: ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Notas de Crédito por Reenvío: ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Notas de Crédito por Pérdida: ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Notas de Crédito por Pérdida: ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Facturación Interna: ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Facturación Externa: ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Facturación para Balance: ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Recibos por Envío: ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Recibos por Envío: ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Recibos por Reenvío: ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Recibos por Reenvío: ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Recibos: ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cantidad de Recibos: ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Retensión: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total de Ingresos: ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Balance Interno: ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Balance Externo: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    ($data.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!$data.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _hoisted_5,
            (!$data.cargando)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.balances, (balance, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"cursor":"pointer"},
                      key: index,
                      class: "card mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h5", _hoisted_8, _toDisplayString(balance._id.medico), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", null, [
                          _hoisted_10,
                          _createTextVNode(_toDisplayString(balance.count), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_11,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.prefactura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_12,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantPrefactura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_13,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.factura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_14,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantFactura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_15,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.refactura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_16,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantRefactura)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_17,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.debito)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_18,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantDeb)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_19,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.creditoAj)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_20,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantCreAj)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_21,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.creditoRe)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_22,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantCreRe)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.creditoPe)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_24,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantCrePe)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_25,
                          _createTextVNode(" " + _toDisplayString($options.formatNumber(
                  balance.prefactura +
                    balance.factura +
                    balance.debito -
                    balance.creditoAj
                )), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString($options.formatNumber(
                  balance.factura +
                    balance.refactura +
                    balance.debito -
                    balance.creditoAj -
                    balance.creditoPe -
                    balance.creditoRe
                )), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_27,
                          _createTextVNode(" " + _toDisplayString($options.formatNumber(
                  balance.prefactura +
                    balance.factura +
                    balance.debito -
                    balance.creditoAj -
                    balance.creditoPe
                )), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_28,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.reciboen)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_29,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantReen)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_30,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.reciboreen)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_31,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantRereen)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_32,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.recibo)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_33,
                          _createTextVNode(_toDisplayString($options.formatNumber2(balance.cantRe)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_34,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.retension)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_35,
                          _createTextVNode(_toDisplayString($options.formatNumber(balance.neto)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_36,
                          _createTextVNode(" " + _toDisplayString($options.formatNumber(
                  balance.prefactura +
                    balance.factura +
                    balance.debito -
                    balance.creditoAj -
                    balance.creditoPe -
                    balance.recibo
                )), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_37,
                          _createTextVNode(" " + _toDisplayString($options.formatNumber(
                  balance.factura +
                    balance.refactura +
                    balance.debito -
                    balance.creditoAj -
                    balance.creditoPe -
                    balance.creditoRe -
                    balance.recibo
                )), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}